import { TRANSACTIONS_LIST_RESPONSE } from "./types";

const INITIAL_STATE = {
  transactionsList: {
    list: [],
    meta: {}
  }
};

const transactions = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TRANSACTIONS_LIST_RESPONSE:
      return {
        ...state,
        transactionsList: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    default:
      return state;
  }
};

export default transactions;
